import { HorizontalLine } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";

import { AnimatedNoResults } from "@faire/retailer/components/SearchProducts/SearchProductsStyles";

interface INoExactResultsContainerProps {
  loadTimingRef?: React.Ref<HTMLDivElement>;
}

const NoExactResultsContainerBase: React.FunctionComponent<
  INoExactResultsContainerProps
> = ({ loadTimingRef }) => {
  return (
    <>
      <AnimatedNoResults>
        <Typography variant="paragraphSansMedium" ref={loadTimingRef}>
          <StrictLocalMsg
            defaultMessage="No results match"
            description={{
              text: "This sentence is shown on the explore page when there are no search results.",
              img: "https://cdn.faire.com/fastly/3fd950d5976b7e1b7b0f3de971307f7d77cf2aee7f5ef302a79306135cb43ca8.png",
            }}
          />
        </Typography>
        <Spacer height="1x" />
        <Typography>
          <StrictLocalMsg
            defaultMessage="Try other keywords."
            description={{
              text: "This sentence is shown on the explore page when there are no search results.",
              img: "https://cdn.faire.com/fastly/3fd950d5976b7e1b7b0f3de971307f7d77cf2aee7f5ef302a79306135cb43ca8.png",
            }}
          />
        </Typography>
      </AnimatedNoResults>
      <HorizontalLine />
      <Spacer height="5x" />
    </>
  );
};

export const NoExactResultsContainer = observer(NoExactResultsContainerBase);
